import { boolean, index, pgTable, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";

import { consentsTable } from "./consentsSchema";
import { patientsTable } from "./patientsSchema";
import { customTimestamp } from "./utils/types";

export const patientConsentsTable = pgTable(
  "patient_consents",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    patientId: uuid("patient_id")
      .references(() => patientsTable.id, { onDelete: "cascade" })
      .notNull(),
    consentId: uuid("consent_id")
      .references(() => consentsTable.id, { onDelete: "cascade" })
      .notNull(),
    isConsented: boolean("is_consented").notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [index("patient_consents_patient_id_index").on(table.patientId)],
);

export const patientConsentSchema = createSelectSchema(patientConsentsTable);
export type PatientConsentType = z.infer<typeof patientConsentSchema>;

export const insertPatientConsentSchema = createInsertSchema(
  patientConsentsTable,
  {
    patientId: z.uuid(),
    consentId: z.uuid(),
  },
).omit({
  createdAt: true,
  updatedAt: true,
});
export type InsertPatientConsentType = z.infer<
  typeof insertPatientConsentSchema
>;
